import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionProyectoInvestigacionDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionProyectoInvestigacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEstadoRevisionProyectoInvestigacionService(): Observable<BodyListResponse<EstadoRevisionProyectoInvestigacionDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionProyectoInvestigacionDTO>>(API_URL + '/api/v1/estadoRevisionProyectoInvestigacion/todos');
  }

  guardarEstadoRevisionProyectoInvestigacionService(estadoRevisionProyectoInvestigacionDTO: EstadoRevisionProyectoInvestigacionDTO): Observable<EstadoRevisionProyectoInvestigacionDTO> {
    return this.http.post<EstadoRevisionProyectoInvestigacionDTO>(API_URL + '/api/v1/estadoRevisionProyectoInvestigacion', estadoRevisionProyectoInvestigacionDTO);
  }

  getEstadoRevisionProyectoInvestigacionPorCodigoEstadoRevisionProyectoInvestigacionService(codigoEstadoRevisionProyectoInvestigacion: string): Observable<BodyResponse<EstadoRevisionProyectoInvestigacionDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionProyectoInvestigacionDTO>>(API_URL + '/api/v1/estadoRevisionProyectoInvestigacion/' + codigoEstadoRevisionProyectoInvestigacion);
  }

  getEstadoRevisionProyectoInvestigacionPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionProyectoInvestigacionDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionProyectoInvestigacionDTO>>(API_URL + '/api/v1/estadoRevisionProyectoInvestigacion/persona/' + codigoPersona);
  }
}
